export default __webpack_public_path__ + "cca7aac8d90dac144adbac812c1a59b9.webp";